import { useTheme } from "../../../../../hook/useThemes";
import { formatNumber } from "../../../../../services/utility/utils";
import "./styles.scss";
import { useEffect, useState } from "react";

interface IPropsTickerLine {
  valueDf: number;
  size?: number;
  coinValue: number;
  isRandom?: boolean;
  isShowLiveCoin?: boolean;
  type?: string;
}

function TickerLine(props: IPropsTickerLine) {
  const { valueDf, coinValue, isShowLiveCoin = true, type } = props;
  const [change, setChange] = useState<number>(coinValue - valueDf);
  const [scale, setScale] = useState<number>(5);

  const { settingImage } = useTheme();

  useEffect(() => {
    setChange(coinValue - valueDf);
    if (coinValue * valueDf > 0) {
      setScale((s) => Math.max(s, Math.abs(coinValue - valueDf)));
    }
  }, [valueDf, coinValue]);

  const translateX = (change * 80) / scale;

  const isBelow = translateX <= 0;

  const translateXAbs = Math.abs(translateX);

  const translate = () => {
    if (translateXAbs > 75) {
      return isBelow ? 10 : 90;
    }
    if (translateXAbs < 10) {
      return isBelow ? 90 : 10;
    }
    return 50;
  };

  return (
    <div
      className="wrapper-ticker-line"
      style={{
        backgroundImage: `url(${settingImage["ticker-line"]})`,
      }}
    >
      <div
        className={`${change > 0 ? "ticker-above" : "ticker-below"}`}
        style={{ transform: `translateX(${translateX}%)` }}
      >
        <svg
          width="13"
          height="13"
          viewBox="0 0 13 13"
          fill="none"
          xmlns="http://www.w3.org/2000/svg"
        >
          <rect
            x="1.396"
            width="6.56899"
            height="6.56899"
            transform="matrix(0.698001 -0.716097 0.698001 0.716097 0.894492 7.13541)"
            fill="currentColor"
            stroke="currentColor"
            strokeWidth="2"
          />
        </svg>
        {isShowLiveCoin && (
          <div
            className={`live-coin-ticker  ${
              !!type && type === "moon" && translateX > 0 && "add-border-moon"
            } ${
              !!type && type === "rekt" && translateX <= 0 && "add-border-rekt"
            }`}
            style={{
              transform: `translate(-${translate()}%)`,
            }}
          >
            <p className="live-coin-value">${formatNumber(coinValue, 2)}</p>
          </div>
        )}
      </div>
    </div>
  );
}

export default TickerLine;
